import { Heightmap } from '../../shared/heightmap.js';

// Loads a region's map files from the server.
export async function loadMap(regionId, onProgress = () => {}) {
  const base = `map/${regionId}`;
  let version = '';
  const get = async (file, kind) => {
    const res = await fetch(`${base}/${file}${version}`, version ? undefined : { cache: 'no-cache' });
    if (!res.ok) throw new Error(`The map file ${file} is missing. Build the map with "npm run map".`);
    return kind === 'json' ? res.json() : res.arrayBuffer();
  };
  onProgress(0.1, 'Reading the map');
  const meta = await get('meta.json', 'json');
  version = `?v=${meta.version || meta.built}`;
  onProgress(0.3, 'Raising the hills');
  const heights = new Uint16Array(await get('height.bin', 'buffer'));
  if (heights.length !== meta.height.w * meta.height.h) throw new Error('The height file does not match the map. Rebuild the map with "npm run map".');
  onProgress(0.8, 'Naming the quarters');
  const places = await get('places.json', 'json');
  onProgress(1, 'Ready');
  return {
    regionId,
    meta,
    places,
    heightmap: new Heightmap(meta.height, heights),
    async loadTile(key) {
      const res = await fetch(`${base}/tiles/${key}.json${version}`);
      if (!res.ok) throw new Error(`tile ${key} failed to load`);
      return res.json();
    },
  };
}

const SETTLEMENT = new Set(['quarter', 'village', 'town']);

// The named quarter, village or town nearest a point, or null beyond maxDist metres.
export function nearestSettlement(places, x, z, maxDist = 2500) {
  let best = null;
  let bestD = maxDist * maxDist;
  for (const p of places) {
    if (!SETTLEMENT.has(p.k)) continue;
    const d = (p.x - x) * (p.x - x) + (p.z - z) * (p.z - z);
    if (d < bestD) {
      bestD = d;
      best = p;
    }
  }
  return best;
}

// Finds a place by name (case-insensitive, partial match), preferring exact matches.
export function findPlace(places, name) {
  const q = name.trim().toLowerCase();
  if (!q) return null;
  let partial = null;
  for (const p of places) {
    const n = p.n.toLowerCase();
    if (n === q) return p;
    if (!partial && n.includes(q)) partial = p;
  }
  return partial;
}
